import React from "react";

import CircularThumbnails from "@is/components/CircularThumbnails";
import { Image } from "@is/components/Image";
import Price from "@is/components/Price";
import { CircularThumbnailSize, MediaVariants } from "@is/constants";
import { ProductItem } from "@is/types";

import css from "./ProductRowItem.module.css";
import useManageProductRowItem from "./hooks/useManageProductRowItem";

type Props = {
  item: ProductItem;
  sectionId: string;
  contentItemId: string;
};

const CIRCULAR_THUMBNAILS_LIMIT = 2;
const CIRCULAR_THUMBNAILS_INTERMEDIATE_LIMIT = 3;

const ProductRowItem = ({ item, sectionId, contentItemId }: Props) => {
  const {
    mediaUrl,
    price,
    handleAllColorsClick,
    handleClick,
    colorVariantsTotalItems,
    colorVariantsThumbnails,
  } = useManageProductRowItem({ item, contentItemId, sectionId });

  return (
    <div className={css.container} onClick={handleClick} data-id={item.id}>
      <div className={css.imageContainer}>
        <Image
          style={{ overflowClipMargin: "unset" }}
          layout="cover"
          mediavariant={MediaVariants.MEDIUM}
          src={mediaUrl}
        />
        <div
          className={css.circularThumbnailsContainer}
          onClick={handleAllColorsClick}
        >
          <CircularThumbnails
            thumbnails={colorVariantsThumbnails}
            totalItems={colorVariantsTotalItems}
            limit={CIRCULAR_THUMBNAILS_LIMIT}
            intermediateLimit={CIRCULAR_THUMBNAILS_INTERMEDIATE_LIMIT}
            thumbnailSize={CircularThumbnailSize.Large}
          />
        </div>
      </div>
      <div className={css.productInfo}>
        <div className={css.title}>{item?.name}</div>
        {price && <Price price={price} />}
      </div>
    </div>
  );
};

export default ProductRowItem;
